import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../App';
import { toast } from 'react-toastify';

function EffectifNouriOrganique() {
  const [stats, setStats] = useState(null);
let token = localStorage.getItem('accessToken');
  useEffect(() => {
    axios
      .get('/personnel/stats/2/organique', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setStats(response.data);
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des statistiques:', error);
      });
  }, []);

  if (!stats) {
    return (
      <div className="container  mt-5 ">
        Veuillez patienter pendant le chargement des effectifs...
        {toast.info('Veuillez patienter pendant le chargement des effectifs...')}
      </div>
    );
  }
  return (
    <div className="mt-3   " style={{ fontSize: 12 }}>
      <div className="row">
        <div className="col">
          <h2 className="bg-warning">EFFECTIFS PAR BATAILLON : </h2>
        </div>
      </div>
      <table border="1" cellPadding="5" cellSpacing="0">
        <thead className="table-dark">
          <tr>
            <th rowSpan="2">Bataillon</th>
            <th rowSpan="2">Compagnie</th>

            {Object.keys(stats[0]?.companies[0]?.grades.OFF || {}).map((grade) => (
              <th key={`off-${grade}`}>{grade}</th>
            ))}
            <th rowSpan="2">Sous-Total OFF</th>

            {Object.keys(stats[0]?.companies[0]?.grades['S-OFF'] || {}).map((grade) => (
              <th key={`soff-${grade}`}>{grade}</th>
            ))}
            <th rowSpan="2">Sous-Total S-OFF</th>

            {Object.keys(stats[0]?.companies[0]?.grades.ADL || {}).map((grade) => (
              <th key={`adl-${grade}`}>{grade}</th>
            ))}
            <th rowSpan="2">Sous-Total ADL</th>

            {Object.keys(stats[0]?.companies[0]?.grades.PDL || {}).map((grade) => (
              <th key={`pdl-${grade}`}>{grade}</th>
            ))}
            <th rowSpan="2">Sous-Total PDL</th>

            {Object.keys(stats[0]?.companies[0]?.grades.CIVIL || {}).map((grade) => (
              <th className="vertical-header" key={`civil-${grade}`}>
                {grade}
              </th>
            ))}
            <th rowSpan="2">Sous-Total CIVIL</th>

            {Object.keys(stats[0]?.companies[0]?.grades.OPERATIONS || {}).map((operation) => (
              <th className="vertical-header" key={`operation-${operation}`}>
                {operation}
              </th>
            ))}
            <th rowSpan="2" className="vertical-header">
              Sous-Total OPERATION
            </th>

            <th rowSpan="2" className="vertical-header">
              Total restant par Compagnie
            </th>
          </tr>
          <tr></tr>
        </thead>
        <tbody>
          {stats.map((battalion) => (
            <React.Fragment key={battalion.battalion}>
              {battalion.companies.map((company, index) => (
                <tr key={`${battalion.battalion}-${company.company}`}>
                  {index === 0 && (
                    <td className="bg-info" rowSpan={battalion.companies.length + 1}>
                      {battalion.battalion}
                    </td>
                  )}
                  <td className="bg-info">{company.company}</td>

                  {Object.values(company.grades.OFF).map((count, i) => (
                    <td className="text-center" key={`off-${i}`}>
                      {count}
                    </td>
                  ))}
                  <td className="bg-danger text-center ">{company.subTotals.OFF}</td>

                  {Object.values(company.grades['S-OFF']).map((count, i) => (
                    <td key={`soff-${i}`}>{count}</td>
                  ))}
                  <td className="bg-danger text-center ">{company.subTotals['S-OFF']}</td>

                  {Object.values(company.grades.ADL).map((count, i) => (
                    <td key={`adl-${i}`}>{count}</td>
                  ))}
                  <td className="bg-danger text-center ">{company.subTotals.ADL}</td>

                  {Object.values(company.grades.PDL).map((count, i) => (
                    <td key={`pdl-${i}`}>{count}</td>
                  ))}
                  <td className="bg-danger text-center ">{company.subTotals.PDL}</td>

                  {Object.values(company.grades.CIVIL).map((count, i) => (
                    <td key={`civil-${i}`}>{count}</td>
                  ))}
                  <td className="bg-danger text-center ">{company.subTotals.CIVIL}</td>

                  {Object.values(company.grades.OPERATIONS).map((count, i) => (
                    <td key={`operation-${i}`}>{count}</td>
                  ))}
                  <td className="bg-warning">{company.subTotals.OPERATION}</td>

                  <td className="bg-warning">{company.subTotals.TOTAL_GENERAL}</td>
                </tr>
              ))}

              <tr>
                <td colSpan="">Total {battalion.battalion}</td>

                {Object.keys(battalion.companies[0].grades.OFF).map((grade) => (
                  <td key={`total-off-${grade}`}>{battalion.companies.reduce((sum, company) => sum + company.grades.OFF[grade], 0)}</td>
                ))}
                <td className="bg-primary">{battalion.totalBattalion.OFF}</td>

                {Object.keys(battalion.companies[0].grades['S-OFF']).map((grade) => (
                  <td key={`total-soff-${grade}`}>{battalion.companies.reduce((sum, company) => sum + company.grades['S-OFF'][grade], 0)}</td>
                ))}
                <td className="bg-primary">{battalion.totalBattalion['S-OFF']}</td>

                {Object.keys(battalion.companies[0].grades.ADL).map((grade) => (
                  <td key={`total-adl-${grade}`}>{battalion.companies.reduce((sum, company) => sum + company.grades.ADL[grade], 0)}</td>
                ))}
                <td className="bg-primary">{battalion.totalBattalion.ADL}</td>

                {Object.keys(battalion.companies[0].grades.PDL).map((grade) => (
                  <td key={`total-pdl-${grade}`}>{battalion.companies.reduce((sum, company) => sum + company.grades.PDL[grade], 0)}</td>
                ))}
                <td className="bg-primary">{battalion.totalBattalion.PDL}</td>

                {Object.keys(battalion.companies[0].grades.CIVIL).map((grade) => (
                  <td key={`total-civil-${grade}`}>{battalion.companies.reduce((sum, company) => sum + company.grades.CIVIL[grade], 0)}</td>
                ))}
                <td className="bg-primary">{battalion.totalBattalion.CIVIL}</td>

                {Object.keys(battalion.companies[0].grades.OPERATIONS).map((operation) => (
                  <td key={`total-operation-${operation}`}>{battalion.companies.reduce((sum, company) => sum + company.grades.OPERATIONS[operation], 0)}</td>
                ))}
                <td className="bg-primary">{battalion.totalBattalion.OPERATION}</td>

                <td className="bg-primary">{battalion.totalBattalion.total}</td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default EffectifNouriOrganique;
